export default class MagnifierIcon extends Phaser.Image {
  constructor(game, x, y, furniture) {
    super(game, x, y, 'magnifier');
    this.anchor.set(0.39, 0.385);
    this.scale.set(0.16);

    this.furniture = furniture;

    this.inputEnabled = true;
    this.events.onInputDown.add(this.handleInputDown, this);
    this.input.pixelPerfectAlpha = 10;
    this.input.pixelPerfectClick = true;
    this.input.pixelPerfectOver = true;
    this.input.useHandCursor = true;

    //
    this.scale.set(0);
    this.visible = false;
    this.active = false;
  }

  get depth() {
    return this.y + 1000;
  }

  handleInputDown() {
    this.furniture.showMacroView();
    this.hide();
  }

  show() {
    this.active = true;
    this.visible = true;
    this.tween && this.tween.stop();
    this.tween = this.game.add
      .tween(this.scale)
      .to({ x: 0.16, y: 0.16 }, 250, Phaser.Easing.Back.Out, true);
  }

  hide() {
    this.active = false;
    this.tween && this.tween.stop();
    this.tween = this.game.add
      .tween(this.scale)
      .to({ x: 0, y: 0 }, 250, Phaser.Easing.Back.In, true);
    this.tween.onComplete.add(this.handleHideEnd, this);
  }

  handleHideEnd() {
    this.visible = false;
  }
}
